export default {
  'aiConsumptions.title': 'Consumos de IA',
  'aiConsumptions.text.year': 'Año',
  'aiConsumptions.text.source.assistant': 'Asistente',
  'aiConsumptions.text.source.processactiontypeopenai': 'Proceso / Acción OpenAI',
  'aiConsumptions.text.source.processactiontypeautomyai': 'Proceso / Acción AUTOMY IA',
  'aiConsumptions.text.source.aiagentconfiguration': 'Configuración de agente IA',
  'aiConsumptions.text.source.runtimeorchestrator': 'Orquestador de agente IA',
  'aiConsumptions.text.provider': 'Proveedor',
  'aiConsumptions.text.provider.openai': 'OpenAI',
  'aiConsumptions.text.family': 'Familia',
  'aiConsumptions.text.inputTokens': 'Tokens de Entrada',
  'aiConsumptions.text.inputTokensCache': 'Tokens de Entrada (Cache)',
  'aiConsumptions.text.outputTokens': 'Tokens de Salida',
  'aiConsumptions.text.outputTokensReasoning': 'Tokens de Salida (Razonamiento)',
  'aiConsumptions.text.totalTokens': 'Tokens',
  'aiConsumptions.text.finalPrice': 'Precio',
  'aiConsumptions.text.model': 'Modelo',
  'aiConsumptions.text.processInstance': 'Solicitud',
  'aiConsumptions.text.actionName': 'Acción',
  'aiConsumptions.text.chatThread': 'Hilo de Chat',
  'aiConsumptions.text.billingMetric': 'Métrica de facturación',
  'aiConsumptions.text.billingMetric.tokens': 'Tokens',
  'aiConsumptions.text.billingMetric.duration': 'Duración',
  'aiConsumptions.text.isLongContext': 'Contexto largo',
  'aiConsumptions.text.connection': 'Conexión',
  'aiConsumptions.text.app': 'App',
};
